import { Controller } from "@hotwired/stimulus"

// Opens / closes the "Move to…" <dialog> for a doc.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event?.preventDefault()
    if (this.hasDialogTarget && typeof this.dialogTarget.showModal === "function") {
      this.dialogTarget.showModal()
    }
  }

  close(event) {
    event?.preventDefault()
    if (this.hasDialogTarget && typeof this.dialogTarget.close === "function") {
      this.dialogTarget.close()
    }
  }
}
